module.exports = __webpack_public_path__ + "static/11-22628deb53b3140657c855e21dea7f89.png";